import { agreementSharedRequestBodySchema, agreementSharedSuccessResponseBodySchema, agreementSharedRedisKeyNotFoundResponseBodySchema, conflictResponseBodySchema as sharedConflictResponseBodySchema, internalServerErrorResponseBodySchema as sharedInternalServerErrorResponseBodySchema, } from './agreement-shared.schema';
// Request
export var agreementEditRequestBodySchema = agreementSharedRequestBodySchema;
// Response code 200
export var agreementEditSuccessResponseBodySchema = agreementSharedSuccessResponseBodySchema;
// Response code 400
export var agreementEditRedisKeyNotFoundResponseBodySchema = agreementSharedRedisKeyNotFoundResponseBodySchema;
// Response code 409 - Agreement for provider exists
export var editAgreementConflictResponseBodySchema = sharedConflictResponseBodySchema;
// Response code 500 - Unexpected exception
export var editAgreementInternalServerErrorResponseBodySchema = sharedInternalServerErrorResponseBodySchema;
